
/* Custom Animate Content library 
Usage:

<div
  data-animate="fade" // *Required - Available option: 'fade', 'slide' and 'zoom'
  data-animate-duration="1" // Optional to override default transition-duration CSS property. Value in seconds
  data-opacity-duration="1" // Optional to override default transition-duration CSS property of opacity. Value in seconds
  data-slide-duration="1" // Optional to override default transition-duration CSS property of opacity. Value in seconds
  data-animate-delay=".15" // Optional to set transition-delay on elemenet. Value in seconds
  data-animate-easing="cubic-bezier(0.550, 0.055, 0.675, 0.190)" // Optional to override default easing
  data-animate-offset="150px" // Optional to override default translateY value for "slide" transition. Can be in px or %
  data-animate-repeat="true" // Optional allow to repeat animation every time element enters viewport.
>

*/

export default function () {
    const myBlocks = document.querySelectorAll('[data-animate]');
    if (myBlocks) {

        const observerConfig = {
            rootMargin: '-12.5% 0% -12.5% 0%',
            threshold: [0.25, 0.5, 0.66]
        };

        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                const thisTarget = entry.target;

                const inView = thisTarget.classList.contains('in-view');
                const outView = thisTarget.classList.contains('out-view');
                const shouldRepeat = thisTarget.getAttribute('data-animate-repeat');

                if (entry.intersectionRatio > 0 && window.scrollDirection === 'down' && !inView) {
                    thisTarget.classList.add('in-view');
                    if (!shouldRepeat) {
                        observer.unobserve(thisTarget);
                    }
                } else if (entry.intersectionRatio > 0 && window.scrollDirection === 'up' && !inView) {
                    thisTarget.classList.add('in-view');
                    if (!shouldRepeat) {
                        observer.unobserve(thisTarget);
                    }
                }
                else if (entry.intersectionRatio < 0.05 && window.scrollDirection === 'down' && inView) {
                    thisTarget.classList.add('out-view');
                } else if (entry.intersectionRatio > 0 && window.scrollDirection === 'up' && outView) {
                    thisTarget.classList.remove('out-view');
                }
                else if (entry.intersectionRatio < 0.25 && window.scrollDirection === 'up' && inView) {
                    thisTarget.classList.remove('in-view');
                }
            });
        }, observerConfig);

        myBlocks.forEach(function (block) {

            // Set Element Custom CSS property
            if (block.hasAttribute('data-animate-duration')) {
                block.style.setProperty('--animate-duration', block.getAttribute('data-animate-duration') + 's');
            }
            if (block.hasAttribute('data-opacity-duration')) {
                block.style.setProperty('--animate-opacity-duration', block.getAttribute('data-opacity-duration') + 's');
            }
            if (block.hasAttribute('data-slide-duration')) {
                block.style.setProperty('--animate-slide-duration', block.getAttribute('data-slide-duration') + 's');
            }
            if (block.hasAttribute('data-animate-delay')) {
                block.style.setProperty('--animate-delay', block.getAttribute('data-animate-delay') + 's');
            }
            if (block.hasAttribute('data-animate-easing')) {
                block.style.setProperty('--animate-easing', block.getAttribute('data-animate-easing'));
            }
            if (block.hasAttribute('data-animate-offset')) {
                block.style.setProperty('--animate-slide-offset', block.getAttribute('data-animate-offset'));
            }

            observer.observe(block);
        });
    }
}